// extracted by mini-css-extract-plugin
export default {"pagination":"_-_-record-it-components-src-misc-Pagination-__pagination","pageNumber":"_-_-record-it-components-src-misc-Pagination-__pageNumber"};